import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-200">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-video w-full overflow-hidden bg-background-100">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 网络安全教育`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            width={720}
            height={480}
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full whitespace-nowrap">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-time-line mr-1"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            {article.publishDate}
          </span>
          <Link
            to={`/article/${article.slug}`}
            className="text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}